























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import CartView from './CartView.vue';
import CartViewB2c from './CartViewB2C.vue';
import CustomerInformation from "./CustomerInformation.vue"
import { CheckoutModel } from '@/models/Cart/Checkout';
import { CheckoutStore } from '@/store/checkoutstate';
import { ApiService } from '@/services/ApiService';

@Component({
    components: {
        CartView,
        CartViewB2c,
        CustomerInformation
    }
})
export default class Checkout extends Vue {
    @Prop()
    protected viewmodel!: CheckoutModel;

    private viewmodelInternal!: CheckoutModel;

    get cart() {
        return CheckoutStore.cart;
    }

    get checkoutmodel(): CheckoutModel {
        return this.viewmodelInternal;
    }

    set checkoutmodel(value: CheckoutModel) {
        this.viewmodelInternal = value;
    }

    constructor() {
        super();
        this.checkoutmodel = this.viewmodel;
    }

    @Watch('cart.cartTotalExclDeliveryCost')
    cartTotalUpdated(newValue: string, oldValue: string) {
        if (newValue !== oldValue) {
            this.setPaymentProvider();
        }
    }

    setPaymentProvider() {
        ApiService.setPaymentProvider(this.checkoutmodel).then(response => {
            if (response && response.data) {
                CheckoutStore.reloadState().then(() => {
                    this.checkoutmodel = response.data;
                    //let checkoutContainer = document.getElementById('checkout-widget');
                    // if (checkoutContainer) {
                    //     checkoutContainer.innerHTML = this.checkoutmodel.paymentWidget.responseString;
                    //     let scriptsTags = checkoutContainer.getElementsByTagName('script');
                    //     for (let i = 0; i < scriptsTags.length; i++) {
                    //         let parentNode = scriptsTags[i].parentNode;
                    //         let newScriptTag = document.createElement('script');
                    //         newScriptTag.type = 'text/javascript';
                    //         newScriptTag.text = scriptsTags[i].text;
                    //         if (parentNode) {
                    //             parentNode.removeChild(scriptsTags[i]);
                    //             parentNode.appendChild(newScriptTag);
                    //         }
                    //     }
                    // }

                    setTimeout(() => this.setShippingOption(), 1000);
                });
            }
        });
    }

    setShippingOption() {
        // window._klarnaCheckout &&
        //     window._klarnaCheckout((api: any) => {
        //         api.on({
        //             shipping_option_change: (data: any) => {
        //                 // console.log(`On shipping option change: ${data}`);
        //                 this.checkoutmodel.klarnaSelectedShippingOption = data;
                        ApiService.setDeliveryProvider(this.checkoutmodel).then(response => {
                            CheckoutStore.reloadState().then(() => {});
                        });
            //         }
            //     });
            // });
    }
}
